import { useFetchGalleryImages } from "../../data"
import { useWidget } from "../../../../providers/widget";
import { GalleryWidgetConfig } from "../../config";
import { useGallery, OPEN_AT_TOP } from "../../providers";
import { getProxiedImageUrl } from "../../../../common/image-proxy";
import ShowAllPhotosButton from "./ShowAllPhotosButton"
import { heroGridRadiusMode, heroGridStyle } from "../../hero-grid"

export default function TwoByFiveGrid() {
    const { options } = useWidget<GalleryWidgetConfig>()
    const { setFullScreenImageIndex } = useGallery()
    const { data } = useFetchGalleryImages(options.filter)
    const allImages = data?.pages?.flatMap((page) => page.result || []) || []
    const first5Images = allImages.slice(0, 5);

    if (first5Images.length === 0) {
        return null
    }

    const [firstImage, ...remainingImages] = first5Images;

    const handleImageClick = (imageIndex: number) => {
        console.log('handleImageClick', imageIndex)
        setFullScreenImageIndex(imageIndex)
    }

    return (
        <div
            className="homerunner-gallery-two-by-five-grid"
            style={heroGridStyle({
                mainShare: options.mainShare,
                gap: options.gap,
                radiusMode: options.radiusMode,
                imageBorderRadius: options.imageBorderRadius,
            })}
            data-hr-radius-mode={heroGridRadiusMode({ radiusMode: options.radiusMode })}
        >
            <div className="homerunner-gallery-two-by-five-grid-container w-full grid grid-cols-2 gap-2">
                {/* First column - Single large image */}
                <div className="homerunner-gallery-two-by-five-main-image gallery-image-container">
                    <button
                        type="button"
                        className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                        onClick={() => handleImageClick(0)}
                    >
                        <img
                            src={getProxiedImageUrl(firstImage.url, 600, 450)}
                            alt={firstImage.caption || `Property image ${firstImage.position}`}
                            className="homerunner-gallery-image"
                        />
                        {/* Hover overlay */}
                        <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
                    </button>
                </div>

                {/* Second column - 2x2 grid of remaining images */}
                <div className="homerunner-gallery-two-by-five-thumbnails grid grid-cols-2 grid-rows-2 gap-2">
                    {remainingImages.slice(0, 4).map((image, index) => (
                        <div key={index} className="homerunner-gallery-two-by-five-thumbnail gallery-image-container">
                            <button
                                type="button"
                                className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                                onClick={() => handleImageClick(index + 1)}
                            >
                                <img
                                    src={getProxiedImageUrl(image.url, 300, 225)}
                                    alt={image.caption || `Property image ${image.position}`}
                                    className="homerunner-gallery-image"
                                />
                                {/* Hover overlay */}
                                <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
                            </button>
                            {/* Show all photos button - positioned over the bottom-right image (index 3). A
                                SIBLING of the opener button above, not nested inside it — a <button> may not
                                validly contain another interactive element. */}
                            {index === 3 && remainingImages.length >= 4 && options.showAllPhotoButton && (
                                <div className="homerunner-gallery-show-all-button-container">
                                    <ShowAllPhotosButton className=" bottom-5 right-5" onClick={() => handleImageClick(OPEN_AT_TOP)} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
